import { useEffect, useState } from "react";
import { Footer, Header } from "../../components";
import { useFetchSinisterData } from "../../hooks/useFetchSinisterData";
import { useSearchParams } from "react-router-dom";
import { Button, Icon } from "atm-global-stylish/dist";
import { isEmpty, showModal } from "../../utils/functions";

export default function SinisterStatus() {
    const [searchParams] = useSearchParams();
    const [id, setId] = useState('');

    useEffect(() => {
        document.title = 'Siniestro - Vista Reclamante';

        setId(searchParams.get('id'));
    }, [searchParams]);

    const { loading, sinister, submit } = useFetchSinisterData(id);

    const [sinisterModal, setSinisterModal] = useState({});
    const [consult, setConsult] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    const formatDate = (timestamp) => {
        let date = new Date(parseInt(`${timestamp}000`));
        return date.toLocaleDateString('es-AR', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    }

    const LoadingData = ({ size = 18, className = '' }) => {
        return (
            <div className={isEmpty(className) ? 'flex mt-1' : className}>
                <Icon.Spinner size={size} color={'#7C1338'} className='animate-spin' />
            </div>
        );
    }

    const RenderItem = ({ ticket, handleClick }) => {
        const tickets = ticket.tickets || [];
        const openTicketCount = tickets.filter(t => t.status.toLowerCase() === 'open').length;

        let conversationIndicator;
        if (ticket.status.toLowerCase() === 'en proceso') {
            if (openTicketCount > 0) {
                conversationIndicator = <span className="flex w-full justify-center text-xs font-bold px-2 py-1.5 rounded-full bg-shiny-pink-lighter text-grey-tx self-center">{openTicketCount} {openTicketCount === 1 ? 'consulta' : 'consultas'} sin respuesta</span>;
            } else if (tickets.length > 0) {
                conversationIndicator = <span className="flex w-full justify-center text-xs font-bold px-2 py-1.5 rounded-full bg-primary text-white self-center">{tickets.length} {tickets.length === 1 ? 'consulta' : 'consultas'} con respuesta</span>;
            } else {
                conversationIndicator = <span className="flex w-full justify-center text-xs font-semibold text-grey-tx border border-primary rounded-full py-1.5 px-2 self-center">Abrir consulta</span>;
            }
        } else {
            conversationIndicator = <span className="flex w-full justify-center text-xs font-bold px-2 py-1.5 rounded-full bg-shiny-pink text-white self-center">{ticket.status}</span>;
        }

        return (
            <div className="grid grid-cols-1 md:grid-cols-12 cursor-pointer transition hover:bg-[#f3f4f6] p-4" onClick={handleClick}>
                <div className="flex flex-col md:col-span-10">
                    <p className="font-medium text-black">{ticket.activity}</p>
                    <p className="text-xs text-dark-grey col-span-10">{formatDate(ticket.date)}</p>
                </div>
                <div className="mt-4 md:mt-0 md:col-span-2 self-center">
                    {conversationIndicator}
                </div>
            </div>
        );
    }

    const RenderItemTickets = ({ tickets }) => {
        const sortedTickets = tickets.sort((a, b) => b.timestamp - a.timestamp);

        return (
            <div>
                {
                    sortedTickets.map((ticket, i) => {
                        const statusClass = ticket.status?.toLowerCase() === 'open' ? 'bg-shiny-pink-lighter text-grey-tx py-1 px-2 rounded-md font-semibold text-xs uppercase' : 'bg-primary text-white py-1 px-2 rounded-md font-semibold text-xs uppercase';
                        const statusText = ticket.status?.toLowerCase() === 'open' ? 'abierto' : 'con respuesta';

                        const responseHtml = ticket.analyst_response ?
                            <div className="border-l-[3px] border-shiny-pink pl-3 italic text-bluish-gray mt-3">
                                <p className="font-semibold text-shiny-pink">Respuesta del Analista:</p>
                                <p className="text-gray-700">{ticket.analyst_response}</p>
                                <p className="text-xs text-dark-grey mt-1">Respondido: {formatDate(ticket.response_date)}</p>
                            </div>
                            : <p className="text-sm text-grey-tx mt-2 italic">Aún no hay respuesta del analista.</p>;

                        return (
                            <div className="border border-light-grey-2 rounded-lg p-3 mb-3 bg-white shadow-sm">
                                <div className="flex justify-between items-center mb-2">
                                    <span className={statusClass}>{statusText}</span>
                                    <span className="text-xs text-grey-tx hidden">ID Ticket: {ticket.uuid}</span>
                                </div>
                                <p className="font-bold text-black">{ticket.question}</p>
                                <p className="text-xs text-grey-tx mt-1">Enviado: {formatDate(ticket.timestamp)}</p>
                                {responseHtml}
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    const sendNewConsult = async () => {
        const question = consult.trim();

        if (isEmpty(question)) {
            return;
        }

        if (isEmpty(sinisterModal.uuid)) {
            return;
        }

        const date = new Date();
        const dateCreated = `${date.getTime()}`.slice(0, -3); //tengo que hacer esto por el formato de fecha que viene del back. Le tuve que agregar 000 al final del timestamp.
        const response = await submit(id, sinisterModal.uuid, question);

        if (response.status === 200) {
            const newTicket = {
                id: '',
                question: question,
                timestamp: dateCreated,
                status: 'OPEN',
                analyst_response: '',
                response_date: 0
            };

            const { tickets } = sinisterModal;
            tickets.push(newTicket);
            setSinisterModal({ ...sinisterModal, ...{ tickets: tickets } });
        } else {
            await showModal('', response.response.data);
        }
    }

    const handleShowModal = (item) => {
        setSinisterModal(item);
        setModalVisible(true);
        document.getElementsByTagName('html')[0].style.overflow = "hidden";
    }

    const handleHideModal = () => {
        setConsult('');
        setSinisterModal({});
        setModalVisible(false);
        document.getElementsByTagName('html')[0].style.overflow = "auto";
    }

    return (
        <>
            <Header />
            {
                modalVisible ?
                    <div id="conversation-modal-claimant" className="fixed inset-0 bg-black bg-opacity-75 modal-overlay content-center justify-items-center z-50">
                        <div className="bg-white rounded-xl shadow-2xl p-6 w-10/12 md:w-3/5 flex flex-col h-5/6">
                            <div className="grid md:grid-cols-12 mb-2 gap-x-4">
                                <span className="md:hidden block text-xs text-grey-tx self-center text-right mb-3">Trámite: {sinister?.sinister_branch.padStart(2, '0')}-{sinister?.sinister_number}/{sinisterModal?.id.toString().padStart(2, '0')}</span>
                                <h3 className="text-xl font-bold text-black self-center md:col-span-10">Consultas sobre: <span id="chat-entry-text-claimant" className="font-normal text-primary">{sinisterModal.activity}</span></h3>
                                <span className="hidden md:block text-xs text-grey-tx self-center text-right col-span-2">Trámite: {sinister?.sinister_branch.padStart(2, '0')}-{sinister?.sinister_number}/{sinisterModal?.id.toString().padStart(2, '0')}</span>
                            </div>
                            {
                                sinisterModal.status.toLowerCase() === 'en proceso' ?
                                    <>
                                        <p className="text-sm text-grey-tx mb-4">La respuesta a tu consulta puede demorar hasta 72hs.</p>
                                        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-3 md:gap-y-0 gap-x-3 mb-4">
                                            <div className="md:col-span-9 self-center">
                                                <input type="text" placeholder="Escribe tu nueva consulta aquí..." class="w-full p-3 border border-light-grey-2 rounded-lg outline-none focus:outline-none focus:ring-2 focus:ring-shiny-pink" value={consult} onChange={(e) => { setConsult(e.target.value) }} maxLength={240} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
                                            </div>
                                            <div className="md:col-span-3 self-center">
                                                <Button className="px-6 py-3 bg-primary text-white !font-medium rounded-lg hover:bg-light-red transition duration-150 shadow-md flex-shrink-0 w-full text-sm" title="Enviar Consulta" handleClick={sendNewConsult} loading={loading} />
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <p className="text-sm text-grey-tx mb-4">Este trámite se encuentra finalizado.</p>
                            }
                            <div id="tickets-area-claimant" className="flex-grow overflow-y-auto p-4 border border-light-grey-2 rounded-lg space-y-3">
                                {
                                    sinisterModal.tickets.length > 0 ?
                                        <RenderItemTickets tickets={sinisterModal.tickets} />
                                        :
                                        <div className="text-center text-bluish-gray text-sm italic">No hay consultas asociadas a este avance. Envía la primera.</div>
                                }
                            </div>

                            <Button handleClick={handleHideModal} title="Cerrar" className="mt-4 px-4 py-2 text-grey-tx rounded-lg hover:bg-light-grey-3 transition" />
                        </div>
                    </div>
                    :
                    <></>
            }

            <div className="p-4 sm:p-8 bg-white">
                <header className="mb-8 flex justify-between items-center">
                    <h1 className="text-3xl font-bold text-black">Estado de tu reclamo</h1>
                    <span className={`px-4 py-2 uppercase rounded-full text-sm font-semibold shadow-md ${sinister?.closed_date !== false ? 'bg-shiny-pink-lighter text-crimson-red' : 'bg-shiny-pink-lighter text-grey-tx'}`}>
                        {sinister?.closed_date === false ? 'abierto' : 'cerrado'}
                    </span>
                </header>
                <div className="bg-white rounded-xl shadow-md px-6 py-3 mb-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm border border-light-grey-3">
                    <div>
                        <p className="text-grey-tx flex flex-row justify-center">Siniestro Nro: {loading ? <LoadingData className='ms-2 self-center' /> : <span className="ms-1 text-black font-bold">{sinister?.sinister_number}</span>}</p>
                    </div>
                    <div>
                        <p className="text-grey-tx flex flex-row justify-center">Ocurrencia: {loading ? <LoadingData className='ms-2 self-center' /> : <span className="ms-1 text-black font-bold">{sinister?.sinister_date}</span>}</p>
                    </div>
                    <div>
                        <p className="text-grey-tx flex flex-row justify-center">Nombre: {loading ? <LoadingData className='ms-2 self-center' /> : <span className="ms-1 text-black font-bold">{sinister?.claimant_name}</span>}</p>
                    </div>
                    <div>
                        <p className="text-grey-tx flex flex-row justify-center">DNI: {loading ? <LoadingData className='ms-2 self-center' /> : <span className="ms-1 text-black font-bold">{sinister?.claimant_dni}</span>}</p>
                    </div>
                </div>
                <div className="bg-white rounded-xl shadow-md p-6 mb-6 border border-light-grey-3">
                    <div className="flex flex-row">
                        <svg className="w-6 h-6 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                        </svg>
                        <h2 className="text-xl font-bold text-black mb-4">
                            Registro de Avances
                            <span className="text-sm ms-1.5 font-bold text-black mb-4 self-end pb-0.5">(Hacé clic para hacer una consulta)</span>
                        </h2>
                    </div>
                    {
                        loading ?
                            <div id="log-list" className="divide-y divide-light-grey-3">
                                <div className="p-3 text-gray-500 text-center">Cargando avances...</div>
                            </div>
                            :
                            <div id="log-list" className="divide-y divide-light-grey-3">
                                {(
                                    sinister.log_entries?.length > 0 ?
                                        sinister.log_entries.map((e, i) => {
                                            return <RenderItem ticket={e} handleClick={() => { handleShowModal(e) }} />
                                        })
                                        :
                                        <p className="text-grey-tx text-sm md:text-base italic">¡UPS! No se encontraron registros, volvé a intentarlo en 24hs.</p>
                                )}
                            </div>
                    }
                </div>

            </div>
            <Footer />
        </>
    );
}